import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import actions from '../../../../store/actions/index'
import Details from './Details'

export default connect(
  state => ({
    data: state.reports,
    user: state.user,
    organizations: state.organizations
  }),
  dispatch => ({
    handlingData: bindActionCreators(actions.reports.handlingData, dispatch),
    getCourseReport: bindActionCreators(
      actions.reports.getCourseReport,
      dispatch
    )
  })
)(Details)
